// Tenant id for the browser Supabase client, kept apart from browser.ts so
// TenantProvider — mounted on every storefront page — can set it without
// importing supabase-js.

let tenantId = "";

/**
 * Set the tenant ID for the browser Supabase client.
 * Called once from TenantProvider when the app mounts.
 */
export function setBrowserTenantId(id: string) {
  tenantId = id;
}

export function getBrowserTenantId(): string {
  return tenantId;
}
